import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import NavbarWhite from "../components/NavbarWhite";
import Footer from "../components/Footer";

const SuccessPage = () => {
  const navigate = useNavigate();
  const [savedOrder, setSavedOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [unauthorized, setUnauthorized] = useState(false);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("latestOrder"));

    if (!stored?.orderId || !stored?.posto || !stored?.order) {
      console.warn("⚠️ Dati mancanti. stored:", stored);
      alert("Dati ordine mancanti. Torni alla home.");
      setUnauthorized(true);
      setLoading(false);
      navigate("/");
      return;
    }

    const total = Object.values(stored.order).reduce(
      (sum, item) => sum + item.qty * item.prezzo,
      0
    );

    const newOrder = {
      ...stored,
      prezzo: total,
      stato: "pagato",       // We assume payment is done if on success page
      completato: "NO",      // Default, can be updated in admin later
    };

    setSavedOrder(newOrder);
    localStorage.removeItem("latestOrder"); // Clean up
    setLoading(false);
  }, [navigate]);

  return (
    <div className="bg-white text-black min-h-screen flex flex-col">
      <NavbarWhite />
      <div className="pt-32 px-4 text-center flex-1 max-w-3xl mx-auto">
        {loading ? (
          <p className="text-gray-500 font-[chivo]">Caricamento ordine...</p>
        ) : unauthorized ? (
          <div className="text-red-600 font-[chivo] text-xl">
            ⚠️ Accesso non autorizzato o ordine non trovato.
          </div>
        ) : savedOrder ? (
          <>
            <h1 className="text-4xl text-[#009FB7] mb-4 font-[chivo]">Pagamento Riuscito ✅</h1>
            <p className="text-lg text-gray-700 mb-6 font-[chivo]">
              Grazie! Il tuo ordine è stato registrato con successo.
            </p>
            <p className="text-sm text-gray-500 mb-10 font-[chivo]">
              Il tuo ordine verrà evaso entro <strong>10–20 minuti</strong>. Ti ringraziamo per la pazienza!
            </p>

            <div className="text-left space-y-4 font-[chivo] text-base sm:text-lg">
              <p><strong>N° Posto:</strong> {savedOrder.posto}</p>
              <p><strong>Stato:</strong> {savedOrder.stato}</p>
              <p><strong>Completato:</strong> {savedOrder.completato}</p>

              <div className="mt-6">
                <h2 className="text-xl font-semibold text-[#009FB7] mb-2">Ordine:</h2>
                <div className="space-y-2">
                  {savedOrder.ordine &&
                    Object.entries(savedOrder.ordine).map(([key, item], idx) => (
                      <div key={idx} className="border-b border-gray-300 pb-2">
                        <p><strong>{item.nome}</strong></p>
                        <p className="text-sm text-gray-600">
                          Quantità: {item.qty} × €{item.prezzo.toFixed(2)} ={" "}
                          <span className="text-[#009FB7] font-semibold">
                            €{(item.qty * item.prezzo).toFixed(2)}
                          </span>
                        </p>
                      </div>
                    ))}
                </div>
              </div>

              <p className="mt-6 text-xl">
                <strong>Totale:</strong>{" "}
                <span className="text-[#009FB7] font-bold">
                  €{savedOrder.prezzo.toFixed(2)}
                </span>
              </p>

              <p className="text-sm text-green-600 mt-4 font-[chivo]">
                📧 Conferma inviata a <strong>{savedOrder.email}</strong>
              </p>
              <p className="text-sm text-gray-600 font-[chivo]">
                📞 Numero fornito: <strong>{savedOrder.phone}</strong>
              </p>
            </div>
          </>
        ) : null}
      </div>
      <Footer />
    </div>
  );
};

export default SuccessPage;
